export default __webpack_public_path__ + "static/media/not-found-spaceman.ba3f8d06.png";